import EntryAvatar from './EntryAvatar';

export default EntryAvatar;
